import { CommonModule, NgOptimizedImage } from '@angular/common';
import { Component, inject } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { ButtonComponent } from '../button/button.component';

@Component({
    selector: 'pims-page-not-found',
    imports: [CommonModule, RouterModule, TranslatePipe, ButtonComponent, NgOptimizedImage],
    templateUrl: './page-not-found.component.html',
    styleUrl: './page-not-found.component.scss',
})
export class PageNotFoundComponent {
    private readonly router = inject(Router);

    redirectToHome() {
        this.router.navigate(['/']);
    }

    goBack() {
        window.history.back();
    }
}
